import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10 1.667a8.333 8.333 0 0 0-6.126 13.966 8.333 8.333 0 0 0 12.25 0A8.333 8.333 0 0 0 10 1.667m0 15a6.67 6.67 0 0 1-4.626-1.875 5 5 0 0 1 9.25 0A6.67 6.67 0 0 1 10 16.667M8.331 8.333a1.667 1.667 0 1 1 3.334 0 1.667 1.667 0 0 1-3.334 0m7.426 5a6.67 6.67 0 0 0-3.259-2.816 3.333 3.333 0 1 0-5 0 6.67 6.67 0 0 0-3.258 2.816A6.6 6.6 0 0 1 3.332 10a6.667 6.667 0 0 1 13.334 0 6.6 6.6 0 0 1-.909 3.333"
    }, null, -1)
  ])))
}
export default { render: render }